import {
  Label,
  useCreateMutation,
  useWorkspaceLabels,
} from '@gripp/shared-logic';
import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useFormContext } from '../../forms';
import { LabelSelector } from '../../issue/labelSelector';
import { useRoutineLabelPicker } from './routineLabelPickerContext';

export const CommonLabel = ({
  workspaceId,
  fieldName,
  title,
  backgroundColor,
}: {
  workspaceId: string;
  fieldName: string;
  title?: string;
  backgroundColor?: string;
}) => {
  const { labels: availableLabels } = useWorkspaceLabels(workspaceId);
  const { mutateAsync: createLabel } = useCreateMutation({
    modelName: 'label',
    query: CREATE_LABEL,
  });
  const { setValue, watch, getValues } = useFormContext();
  const labelPicker = useRoutineLabelPicker();

  const handleLabelsChange = useCallback(
    (labels: Label[]) => {
      setValue(fieldName, labels, {
        shouldDirty: true,
        shouldValidate: true,
      });
    },
    [fieldName, setValue]
  );

  const handleCreateLabel = async (name: string) => {
    try {
      const result = await createLabel({
        input: { name, workspace: { id: workspaceId } },
      });
      return result;
    } catch (error) {
      console.error('Failed to create label:', error);
      throw error;
    }
  };

  const onSelectorEdit = labelPicker
    ? () =>
        labelPicker.openLabelPicker({
          workspaceId,
          initialItems: getValues(fieldName) || [],
          onChange: handleLabelsChange,
        })
    : undefined;

  return (
    <View style={[styles.formItem, backgroundColor && { backgroundColor }]}>
      <LabelSelector
        selectedLabels={watch(fieldName) || []}
        availableLabels={availableLabels}
        onLabelsChange={handleLabelsChange}
        onCreateLabel={handleCreateLabel}
        title={title}
        containerBackgroundColor={backgroundColor}
        onSelectorEdit={onSelectorEdit}
      />
    </View>
  );
};

const CREATE_LABEL = `
  mutation CreateLabel($input: CreateLabelInput!) {
    createLabel(input: $input) {
      id
      name
    }
  }
`;

const styles = StyleSheet.create({
  formItem: {
    marginBottom: 4,
    borderRadius: 8,
  },
});
